/*
 * Main navigation is generated from the typed module registry so route
 * prefixes, Auth0 permission names, menu placement, and icons stay in sync.
 */
import { moduleRegistry, navigationGroups } from '../config/moduleRegistry';

const main = [
        {
                name: 'Dashboard',
                to: '/dashboard',
                icon: 'si si-speedometer',
        },
        ...navigationGroups.map((group) => ({
                ...group,
                sub: moduleRegistry
                        .filter((module) => module.group === group.name)
                        .map((module) => ({
                                name: module.name,
                                to: module.routePrefix,
                                module: module.permission,
                        })),
        })),
];

export default { main };